import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Tabs from '~/components/ui/Tabs';
import { LOCATION_TYPE } from '~/constants/vCard';

import { Address } from './components/address/Address';
import { Coordinates } from './components/coordinates/Coordinates';
import { Url } from './components/url/Url';
import { StyledTabsContainer } from './styled';

export const LocationContent = () => {
  const { t } = useTranslation();

  const tabsList = [
    { value: LOCATION_TYPE.FULL, label: t('template5:complete') },
    { value: LOCATION_TYPE.URL, label: t('template5:url') },
    { value: LOCATION_TYPE.COORDINATES, label: t('template5:coordinate') },
  ];

  return (
    <Controller
      name="location.type"
      render={({ field: { value, onChange } }) => (
        <StyledTabsContainer>
          <Tabs tabs={tabsList} value={value} onChange={(_, newValue) => onChange(newValue)} />
          {value === LOCATION_TYPE.FULL && <Address />}
          {value === LOCATION_TYPE.URL && <Url />}
          {value === LOCATION_TYPE.COORDINATES && <Coordinates />}
        </StyledTabsContainer>
      )}
    />
  );
};
